import React,{ useEffect,useState } from 'react';
import Input from '../Common/Input';
import InputMask from '../Common/InputMask';
import Select from '../Common/Select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from '../Common/ReactSelect';

const Form = ({ formik }) => {

    const [branchs,setBranchs] = useState([]);
    const [roles,setRoles] = useState([]);
    const [personnelTypes,setPersonnelTypes] = useState([]);
    const {readData: getBranchs} = useEntityCrud('Branch/GetAllBranchs');
    const {readData: getRoles} = useEntityCrud('Role/GetAllRole');
    const {readData: getPersonnelTypes} = useEntityCrud('PersonType/GetAllPersonTypes');

    useEffect(() => {
        getBranchs().then(({data}) => {
            let branchesData = [];
            if(data.status)
                data.result.map(item => {
                    branchesData.push({
                        label: item.title,
                        value: item.id
                    })
                })
            setBranchs(branchesData);
        });
        getRoles().then(({data}) => {
            if(data.status)
                setRoles(data.result);
        });
        getPersonnelTypes().then(({data}) => {
            if(data.status)
                setPersonnelTypes(data.result);
        });
    },[]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <Input label="نام" name="name" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <Input label="نام خانوادگی" name="lastName" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <Input label="کد ملی" name="nationalCode" required={true} isLtr={true} formik={formik} type="tel" maxLength="10" />
                </div>
                <div className="col-md-3">
                    <Input label="آدرس ایمیل" name="email" formik={formik} isLtr={true} type="email" />
                </div>
                <div className="col-md-3">
                    <InputMask label="شماره تماس" name="phone" formik={formik} isLtr={true} type="tel" mask="999-99999999" />
                </div>
                <div className="col-md-3">
                    <InputMask label="شماره همراه" name="cellphone" required={true} formik={formik} isLtr={true} type="tel" mask="9999-9999999" />
                </div>
                <div className="col-md-3">
                    <ReactSelect label="شرکت" name="branchId" formik={formik} required={true} options={branchs} value={branchs.find(b => b.value == formik.values.branchId)} /> 
                </div>
   {/*              <div className="col-md-3">
                    <Select label="نقش" name="roleId" formik={formik} required={true}>
                        {roles.map(option => (
                            <option value={option.id} key={option.id}>{option.title}</option>
                        ))}
                    </Select>
                </div> */}
                <div className="col-md-3">
                    <Select label="نوع پرسنل" name="personTypeId" formik={formik} required={true}>
                        {personnelTypes.map(option => (
                            <option value={option.id} key={option.id}>{option.title}</option>
                        ))}
                    </Select>
                </div>
            </div>
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;